var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
import React, { useMemo, useState } from 'react';

import { useLoaderData, useRevalidator } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import * as extractorsAPI from "../../../api/ix/extractors";
import * as templatesAPI from "../../../api/templates";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";

import { Button, ConfirmationModal, Table } from "../../../Components/UI";
import { Translate, t } from "../../../../I18N";
import { notificationAtom } from "../../../atoms";

import { ExtractorModal } from "./components/ExtractorModal";
import { extractorsTableColumns } from "./components/TableElements";
import { List } from "./components/List";


const formatExtractors = (
extractors,
templates) =>

extractors.map((extractor) => {
  let propertyType = 'text';
  let propertyLabel = '';

  const namedTemplates = extractor.templates.map((extractorTemplate) => {var _templates$find;
    const templateName =
    ((_templates$find = templates.find((template) => template._id === extractorTemplate)) === null || _templates$find === void 0 ? void 0 : _templates$find.name) || extractorTemplate;
    return templateName;
  });

  templates.forEach((template) => {
    const property = template.properties.find(
      (templateProperty) => templateProperty.name === extractor.property
    );

    if (!property && !propertyLabel) {
      propertyLabel = t(template._id, 'Title', null, false);
    }

    if (property) {
      propertyType = property.type;
      propertyLabel = t(template._id, property.label, null, false);
    }
  });

  return _objectSpread(_objectSpread({}, extractor), {}, { rowId: extractor._id, namedTemplates, propertyType, propertyLabel });
});

const IXDashboard = () => {
  const { extractors, templates } = useLoaderData();



  const [isSaving, setIsSaving] = useState(false);
  const revalidator = useRevalidator();
  const [selected, setSelected] = useState();
  const [confirmModal, setConfirmModal] = useState(false);
  const [extractorModal, setExtractorModal] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);

  const formmatedExtractors = useMemo(
    () => formatExtractors(extractors, templates),
    [extractors, templates]
  );

  const deleteExtractors = async () => {
    setIsSaving(true);
    const extractorIds = selected === null || selected === void 0 ? void 0 : selected.map((selection) => selection._id);

    try {
      await extractorsAPI.remove(extractorIds);
      revalidator.revalidate();
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Extractor/s deleted")
      });
    } catch (error) {var _error$json;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_error$json = error.json) !== null && _error$json !== void 0 && _error$json.prettyMessage ? error.json.prettyMessage : undefined
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleSave = async (extractor) => {
    setIsSaving(true);

    try {
      await extractorsAPI.save(extractor);
      revalidator.revalidate();
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Saved successfully.")
      });
    } catch (error) {var _error$json2;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_error$json2 = error.json) !== null && _error$json2 !== void 0 && _error$json2.prettyMessage ? error.json.prettyMessage : undefined
      });
    } finally {
      setIsSaving(false);
    }

    setExtractorModal(false);
  };

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      "data-testid": "settings-ix",
      style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Metadata extraction" }), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: formmatedExtractors,
      columns: extractorsTableColumns,
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Extractors"

      ),

      enableSelections: true,
      onChange: ({ selectedRows }) => {
        setSelected(() => formmatedExtractors.filter((ex) => ex.rowId in selectedRows));
      },
      defaultSorting: [{ id: 'name', desc: false }] }
    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, { className: "flex gap-2" }, void 0,
    (selected === null || selected === void 0 ? void 0 : selected.length) === 1 ? /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: () => setExtractorModal(true), disabled: isSaving }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Edit Extractor")
    ) :
    undefined,

    selected !== null && selected !== void 0 && selected.length ? /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      color: "error",
      onClick: () => setConfirmModal(true),
      disabled: isSaving }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ) : /*#__PURE__*/

    _jsx(Button, { type: "button", onClick: () => setExtractorModal(true), disabled: isSaving }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Create Extractor")
    )

    )
    ),

    confirmModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: "Delete extractors",
      warningText: "Do you want to delete the following items?",
      body: /*#__PURE__*/_jsx(List, { items: selected || [] }),
      onAcceptClick: async () => {
        await deleteExtractors();
        setConfirmModal(false);
        setSelected([]);
      },
      onCancelClick: () => setConfirmModal(false),
      dangerStyle: true }
    ),


    extractorModal && /*#__PURE__*/
    _jsx(ExtractorModal, {
      setShowModal: setExtractorModal,
      onClose: () => setExtractorModal(false),
      onAccept: async (extractor) => handleSave(extractor),
      templates: templates,
      extractor: selected !== null && selected !== void 0 && selected.length ? selected[0] : undefined }
    )

    ));

};

const IXdashboardLoader =
(headers) =>
async () => {
  const extractors = await extractorsAPI.get(headers);
  const templates = await templatesAPI.get(headers);
  return { extractors, templates };
};

export { IXDashboard, IXdashboardLoader, formatExtractors };